<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import {required} from "vuelidate/lib/validators";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "Transaction history List",
      items: [
        {
          text: "Transaction",
          href: "/",
        },
        {
          text: "History List",
          active: true,
        },
      ],
      histories: [],
        errors:null,
        visible:false,
        message:"",
        search_trId:"",
        search_rtype:"",
        formSubmitted:false,
        search:"",
        form: {
            userId: "",
            amount: "",
            paymentID:"",
            trxID:"",
            sku:"",
            reason:""
        },
        submitform: false,
        submitted: false,
    };
  },
    validations: {
        form: {
            userId: {
                required,
            },
            amount: {
                required,
            },
            paymentID: {
                required,
            },
            trxID: {
                required,
            }, sku: {
                required,
            },
            reason: {
                required,
            },

        },
    },
  mounted() {
    this.getHistoryList();
  },
    computed: {
        filteredList() {
            return this.histories.filter(history => {
                return (history.transaction_id==null ? '' : history.transaction_id).toLowerCase().includes(this.search_trId.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
      refundToBkash(history){
            let resp=JSON.parse(history.response);
            this.form.userId=history.user_id;
            this.form.amount=resp.amount;
            this.form.paymentID=resp.paymentID;
            this.form.trxID=resp.trxID;
            this.form.sku=history.transaction_id;
      },
      // refundToBkash(history){
      //     var _this = this;
      //     _this.form.userId=history.user_id;
      //     try {
      //         this.$swal({
      //             title: "Bkash Refund",
      //             text: "You can't revert your action",
      //             html:
      //                 '<div>fdeasd</div><br><input type="text" value="ffff" id="swal-input1" class="swal2-input" placeholder="Enter Amount">' +
      //                 '<input type="text" id="swal-input2" class="swal2-input" placeholder="Type Payment ID">'+
      //                 '<input type="text" id="swal-input3" class="swal2-input" placeholder="Enter Transaction ID">'+
      //                 '<input type="text" id="swal-input4" class="swal2-input" placeholder="Enter Sku">'+
      //                 '<input type="text" id="swal-input5" class="swal2-input" placeholder="Type Reason">'
      //             ,
      //             preConfirm: function () {
      //                 var as='';
      //                 return new Promise(function (resolve) {
      //                     resolve([$("#swal-input1").val()=='' ? as+='Amount is not set<br>':$("#swal-input1").val() ,
      //                         $("#swal-input2").val()=='' ? as+='Payment ID ID not set<br>' : $("#swal-input2").val(),
      //                         $("#swal-input3").val()=='' ? as+='Transaction ID not set<br>' : $("#swal-input3").val() ,
      //                        ]);
      //                     if(as != ''){
      //                         Swal.showValidationMessage(as)
      //                     }
      //                 });
      //             },
      //             onOpen: function () {
      //                 $("#swal-input1").focus();
      //             },
      //         })
      //             .then(function (result) {
      //                 if (
      //                     result.isConfirmed &&
      //                     result.value[0] != "" &&
      //                     result.value[1] != "" &&
      //                     result.value[2] != "" &&
      //                     result.value[3] != "" &&
      //                     result.value[4] != ""
      //                 ) {
      //                     _this.form.amount = result.value[0];
      //                     _this.form.paymentID = result.value[1];
      //                     _this.form.trxID= result.value[2];
      //                     _this.form.sku=result.value[3];
      //                     _this.form.reason=result.value[4];
      //                     _this.formSubmit(history.user_id);
      //                 } else {
      //                     _this.$swal("Cancelled", "Refund is not set", "info");
      //                 }
      //             })
      //             .catch((err) => {
      //                 console.log(err);
      //             });
      //     } catch (err) {
      //         console.log(err);
      //     }
      // },
      formSubmit() {
          this.submitted = true;
          this.formSubmitted=true;
          this.$v.$touch();
          axios
              .post("/api/bkash-pay-refund", {
                  userId: this.form.userId,
                  amount: this.form.amount,
                  paymentID: this.form.paymentID,
                  trxID: this.form.trxID,
                  sku: this.form.sku,
                  reason: this.form.reason,
                  accessToken: localStorage.getItem("access_tocken"),
              })
              .then((response) => {
                  this.formSubmitted=false;
                  if (response.data.status) {
                      this.$bvModal.hide('modal-1');
                      this.$swal("Bkash Refund", "success");
                      this.getHistoryList();
                  } else {
                      var str = response.data.message;
                      var jsonParse = JSON.parse(str);
                      this.errorCheck(jsonParse);
                  }
              })
              .catch((error) => {
                  if (error.response != undefined) {
                      this.errors = error.response.data.errors;
                  }
              });
      },
    async getHistoryList() {
      try {
        axios
          .get("/api/transaction-histories-list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.histories = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">

        <b-modal id="modal-1" title="Bkash Refund" hide-footer size="lg" centered>
            <div class="card-body">
                                                <div v-if="errors" class="font-bold mb-4 ">
                                                    <p class="text-sm">
                                                    {{errors}}
                                                    </p>
<!--                                                  <div v-for="(v, k) in errors" :key="k">-->
<!--                                                    <p v-for="error in v" :key="error" class="text-sm">-->
<!--                                                      {{ error }}-->
<!--                                                    </p>-->
<!--                                                  </div>-->
                                                </div>
                <form ref="bkashrefun" @submit.prevent="formSubmit">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="required" for="amount">Amount</label>
                                                            <input
                                                                id="amount"
                                                                v-model="form.amount"
                                                                name="amount"
                                                                type="text"
                                                                class="form-control"
                                                                :disabled="true"
                                                                placeholder="Type amoount"
                                                                value
                                                                :class="{ 'is-invalid': submitted && $v.form.amount.$error }"
                                                            />
                                                            <div
                                                                v-if="submitted && $v.form.amount.$error"
                                                                class="invalid-feedback"
                                                            >
                                                                <span v-if="!$v.form.role_name.required">This value is required.</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label class="required" for="paymentID">Payment ID</label>
                                                        <input
                                                            id="paymentID"
                                                            v-model="form.paymentID"
                                                            name="paymentID"
                                                            type="text"
                                                            :disabled="true"
                                                            class="form-control"
                                                            placeholder="Type PaymentID"
                                                            value
                                                            :class="{ 'is-invalid': submitted && $v.form.paymentID.$error }"
                                                        />
                                                        <div
                                                            v-if="submitted && $v.form.paymentID.$error"
                                                            class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.paymentID.required">This value is required.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label class="required" for="trxID">TrxId</label>
                                                        <input
                                                            id="trxID"
                                                            v-model="form.trxID"
                                                            name="trxID"
                                                            type="text"
                                                            :disabled="true"
                                                            class="form-control"
                                                            placeholder="Type TransactioId"
                                                            value
                                                            :class="{ 'is-invalid': submitted && $v.form.trxID.$error }"
                                                        />
                                                        <div
                                                            v-if="submitted && $v.form.trxID.$error"
                                                            class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.trxID.required">This value is required.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label class="required"  for="sku">Sku</label>
                                                        <input
                                                            id="sku"
                                                            v-model="form.sku"
                                                            :disabled="true"
                                                            name="sku"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Type SKU"
                                                        />
<!--                                                        <div-->
<!--                                                            v-if="submitted && $v.form.sku.$error"-->
<!--                                                            class="invalid-feedback"-->
<!--                                                        >-->
<!--                                                            <span v-if="!$v.form.sku.required">This value is required.</span>-->
<!--                                                        </div>-->
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label class="required"  for="reason">Reason</label>
                                                        <input
                                                            id="reason"
                                                            v-model="form.reason"
                                                            name="reason"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Type Reason"
                                                        />
                                                        <div
                                                            v-if="submitted && $v.form.reason.$error"
                                                            class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.reason.required">This value is required.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>

<!--                    <div class="row">-->
<!--                        <div class="col-lg-12">-->
<!--                            <div class="form-group">-->
<!--                                <label for="subject">Subject</label>-->
<!--                                <textarea class="form-control" id="subject" rows="3"></textarea>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="text-right">
                                <button v-if="!this.formSubmitted" type="submit" class="btn btn-primary">Submit</button>
                                <b-spinner v-if="this.formSubmitted" class="m-2" variant="secondary" role="status"></b-spinner>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Transaction ID</th>
                    <th>Amount</th>
                      <th>Payment Gateway</th>
                      <th>Status</th>
                      <th>Transaction Date</th>
                      <th>Charge Type</th>
                      <th>Charge</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp</td>
                    <td><input type="text" class="app-search form-control" v-model="search_trId" placeholder="Search " /></td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_rtype" placeholder="Search " /></td>-->

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(history,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{history.transaction_id}}</td>
                    <td>{{history.amount}}</td>
                      <td>{{history.payment_gateway.name}}</td>
                      <td>{{history.status}}</td>
                      <td>{{history.created_at|  moment("D MMM YYYY, H:mm")}}</td>
                      <td>{{history.payment_gateway.charge_type}}</td>
                      <td>{{history.payment_gateway.charge}}</td>
<!--                      <td v-if="history.payment_gateway.value==='bkash-pay'"><b-button @click.prevent="refundToBkash(history)" >Refund</b-button></td>-->
                    <td v-if="history.payment_gateway.value==='bkash-pay' && history.status==='verified' && history.is_refundable" ><button v-b-modal.modal-1 @click.prevent="refundToBkash(history)" class="btn btn-primary btn-small">Refund</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.modal-footer{
    display:none!important;
}
</style>
